(ns practitest.frontend.version-updates.events
  (:require
   [practitest.frontend.common-old-fe.logging :as log]
   [practitest.frontend.routing.router :as router]
   [re-frame.core :as re-frame]))


(re-frame/reg-event-fx
 ::handle-version-update
 [[re-frame/trim-v]]
 (fn [{:keys [db]} [message]]
   (log/info ::handle-version-update "Received version update message" message)
   (let [{:keys [update-type]} message
         has-unsaved-changes? (router/any-form-dirty?)
         display-type (when update-type
                        (cond
                          (and (= update-type "CRITICAL") (not has-unsaved-changes?)) :critical-modal
                          (and (= update-type "CRITICAL") has-unsaved-changes?) :critical-with-unsaved-changes
                          (= update-type "NOT_CRITICAL") :non-critical-notification
                          :else nil))
         version-update-state (when update-type
                                {:type update-type
                                 :display-type display-type})]
     {:db (assoc db :version-update version-update-state)})))

(re-frame/reg-event-fx
  ::update-version-update-display-type
  [[re-frame/trim-v]]
  (fn [{:keys [db]} [display-type]]
    (log/info ::update-version-update "Updating version update")
    {:db (assoc-in db [:version-update :display-type] display-type)}))

(re-frame/reg-event-fx
  ::refresh-page
  (fn [{:keys [db]} []]
    ;; Clear the version update before refreshing
    {:db (assoc db :version-update nil)
     :fx [[:dispatch-later {:ms 100 :dispatch [::do-refresh]}]]}))

(re-frame/reg-event-fx
  ::do-refresh
  (fn [_ []]
    (js/location.reload)))